import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import VimeoPlayer from 'react-vimeo-fork-pocketjoso'
import InViewMonitor from 'react-inview-monitor'

import Icon from '../components/Icon'
import Button from '../components/Button'
import PageSection from '../components/PageSection'
import HomePageHeroSection from '../components/HomePageHeroSection'
import HomePageSubSection from '../components/HomePageSubSection'
import GenericCtaModule from '../components/GenericCtaModule'
import Video from '../components/Video'
import VideoPlayer from '../components/VideoPlayer'
import VideoPlayButton from '../components/VideoPlayButton'
import VideoAutoplayInView from '../components/VideoAutoplayInView'
import AirstreamCarousel from '../components/AirstreamCarousel'
import SocialFollowButtons from '../components/SocialFollowButtons'

import { IS_PROD, IS_SANDBOX, MAKERS_URL } from '../../config/'

import { trackEvent } from '../../utils/tracking'

import { AIRSTREAM_SLIDES } from '../pages/AirstreamPage'

// should be moved to wordpress, but currently the icons are not re-usable so waiting for quentin
// to fix that before we move to wp (and start defining the icon there, as a string)
const PLATFORM_FEATURES = [
  { icon: 'closed_eye', caption: 'Privacy by Design' },
  { icon: 'eu-gdpr', caption: 'GDPR Compliant' },
  { icon: 'on-device', caption: 'On-Device' },
  { icon: 'plane', caption: 'Offline' },
  { icon: 'multilingual', caption: 'Multilingual' },
  { icon: 'room', caption: 'Multi-room' },
  { icon: 'data-gen', caption: 'Data Generation' },
  { icon: 'bell', caption: 'Wake Word' },
  { icon: 'mouth', caption: 'Specialized Language Model' },
  { icon: 'graph', caption: 'Performance Metrics' },
  { icon: 'entity', caption: 'Entity Extension' },
  { icon: 'cross-platform', caption: 'Cross Platform' },
  { icon: 'cart', caption: 'Skill Store' },
  { icon: 'bubble-dialog', caption: 'Multi Turn Dialog' },
  { icon: 'asr', caption: 'ASR' },
  { icon: 'nlu', caption: 'NLU' }
]

const HOTEL_FULL_VIDEO = 'static/videos/hotel.mp4'
const HOTEL_LOOP_VIDEO = 'static/videos/hotel-loop.mp4'
class HomePageAnimatedHotel extends Component {
  constructor () {
    super()
    this.state = {
      showHotelLoopVideo: false
    }
    this.startLoopVideo = this.startLoopVideo.bind(this)
  }
  startLoopVideo () {
    this.setState({ showHotelLoopVideo: true })
  }

  render () {
    const { showHotelLoopVideo } = this.state
    return (
      <div className='homepage__conclusion__image xs-hide sm-hide relative'>
        {/*
          2 separate videos are used here:
          - at the top layer we have a loop video, only shown _after the other video has finished.
          - at the bottom we have the first video, which does not loop.
          We use two layered videos to transition between them without any flash of nothing,
          as we otherwise get if we just swap the source.
          */}
        <div
          className='absolute top-0 left-0 right-0 bottom-0'
          style={{
            zIndex: '1',
            opacity: showHotelLoopVideo ? undefined : '0'
          }}
        >
          <InViewMonitor
            childPropsInView={{ src: HOTEL_LOOP_VIDEO }}
            toggleChildPropsOnInView
          >
            <Video controls={false} isPlaying={showHotelLoopVideo} />
          </InViewMonitor>
        </div>
        <VideoAutoplayInView
          controls={false}
          src={HOTEL_FULL_VIDEO}
          loop={false}
          onVideoEnded={this.startLoopVideo}
        />
      </div>
    )
  }
}

class HomePagePlatformFeaturesList extends Component {
  constructor () {
    super()
    this.state = {
      showingAll: true
    }
  }
  componentDidMount () {
    // as long as this component is shown (way) below the fold it’s fine to
    // start by showing all features, and only hide the extra ones with JS on load,
    // since it should happen before user has scrolled down this far.
    if (window.innerWidth < 640) {
      // 640 == $md breakpoint
      this.setState({ showingAll: false })
    }
  }
  render () {
    const { features, className } = this.props
    const { showingAll } = this.state
    const featuresToShow = showingAll ? features : features.slice(0, 6)
    return (
      <div className='center'>
        <div className={className}>
          {featuresToShow.map(({ icon, caption }, idx) => (
            <figure
              key={idx}
              className='homepage__platform-features-item flex flex-column items-center mb3'
            >
              <Icon icon={icon} />
              <figcaption className='small strong center'>{caption}</figcaption>
            </figure>
          ))}
        </div>
        {!showingAll && (
          <Button
            className='button button--secondary'
            onClick={() => this.setState({ showingAll: true })}
          >
            Show more features
          </Button>
        )}
      </div>
    )
  }
}

class VimeoPlayerWrapper extends Component {
  constructor () {
    super()
    this.initialise = this.initialise.bind(this)
  }
  componentDidUpdate () {
    this.initialise()
  }
  componentDidMount () {
    this.initialise()
  }
  initialise () {
    const { videoId } = this.props
    if (!this.domEl || !videoId || this._hasInitiated) return
    this._hasInitiated = true
    ReactDOM.render(
      <VimeoPlayer videoId={videoId} playButton={<VideoPlayButton />} />,
      this.domEl
    )
  }
  render () {
    return (
      <div
        className={this.props.className}
        ref={el => {
          this.domEl = el
        }}
      />
    )
  }
}

export const HomePage = ({
  data: {
    acf: {
      heroTitleFirstLine,
      heroTitleSecondLine,
      heroContent,

      heroCtaButtonLabel,
      heroCtaButtonSubtitle,
      heroDemoButtonLabel,
      heroDemoButtonSubtitle,

      // voiceIntroSectionTitle, // not used
      voiceIntroSectionContent,

      buildAssistantStepsSectionTitle,
      buildAssistantSteps,

      communitySectionTitle,
      communitySectionContent,
      communitySectionVimeoVideoId,

      // pressLinks: pressLinksData, // not used

      privacySectionTitle,
      privacySectionSubtitle,

      bottomCtaTitle,
      bottomCtaButtonLabel
    },
    link,
    slug
  }
}) => {
  return (
    <main className='main homepage__main maxw-xxlarge mx-auto'>
      {/* <div className='overlay'>{ overlay grid for dev}</div> */}
      <HomePageHeroSection
        titleFirstLine={heroTitleFirstLine}
        titleSecondLine={heroTitleSecondLine}
        content={heroContent}
        ctaButtonLabel={heroCtaButtonLabel}
        ctaButtonSubtitle={heroCtaButtonSubtitle}
        demoButtonLabel={heroDemoButtonLabel}
        demoButtonSubtitle={heroDemoButtonSubtitle}
      />

      <PageSection
        extraClass='page-section--small homepage__intro center col-12'
        beforeSection={
          <div className='homepage__intro__video-player-wrap mx-auto'>
            <VideoPlayer
              videoPlayerExtraClass='homepage__intro__video-player mx-auto overflow-hidden'
              videoClassName='homepage__intro__video absolute top-0 left-0 right-0 bottom-0'
              poster='/static/images/snips-brand-video-cover.jpg'
              preload='metadata'
              muted={false}
              loop={false}
              src='/static/videos/snips-brand-video2.mp4'
            />
          </div>
        }
      >
        <div className='homepage__intro__inner relative'>
          <div className='homepage__intro__text'>
            <div
              className='col-10 md-col-8 lg-col-6 mx-auto text-para white'
              dangerouslySetInnerHTML={{ __html: voiceIntroSectionContent }}
            />
          </div>
        </div>
      </PageSection>

      {buildAssistantSteps &&
        buildAssistantSteps.length > 0 && (
          <PageSection extraClass='homepage__how-to page-section--full-width'>
            <div className='homepage__how-to__inner'>
              <h2 className='homepage__how-to__title h2 center mb4'>
                {buildAssistantStepsSectionTitle}
              </h2>
              <div className='homepage__how-to__content'>
                {buildAssistantSteps.map((opts, idx) => {
                  return <HomePageSubSection key={idx} {...opts} />
                })}
              </div>
            </div>
          </PageSection>
        )}

      {// Replaced by the airstream content.
      // Code is preserved in case we need to re-use it.
      false && (
        <PageSection extraClass='homepage__community white'>
          <div className='col-10 md-col-8 mx-auto center'>
            <div className='maxw-text mx-auto bg-primary'>
              <h2 className='h2 strong mb3'>{communitySectionTitle}</h2>
              <div
                className='text-para white mb4'
                dangerouslySetInnerHTML={{ __html: communitySectionContent }}
              />
            </div>
            <VimeoPlayerWrapper
              className='homepage__community__video'
              videoId={communitySectionVimeoVideoId}
            />
          </div>
        </PageSection>
      )}

      <PageSection extraClass='airstream-page__intro'>
        <h2 className='h2 mb4 center'>Experience Snips</h2>
        <div className='py3 mb3 overflow-hidden'>
          <AirstreamCarousel slides={AIRSTREAM_SLIDES} />
        </div>
        <div className='col-12 lg-col-10 mx-auto'>
          <div className='small text-para mb4 maxw-text mx-auto center'>
            This summer, Snips is journeying 7,500 miles across America in a
            futuristic, voice-controlled Airstream to explore the biggest
            questions around AI, Voice, and data privacy.<br />
            <br />
            The #VoicesofPrivacy Tour is an immersive, interactive exploration
            of artificial intelligence and data privacy in our connected world.
          </div>
          <div className='center mb3 grey'>
            <div className='mb2'>
              <SocialFollowButtons
                networks={['instagram', 'facebook', 'twitter']}
              />
            </div>
            <div className='h4 mb2'>Explore with us @snips.ai</div>
          </div>
        </div>
      </PageSection>

      <PageSection extraClass='homepage__platform-features maxw-xxlarge bg-white mx-auto'>
        <div className='homepage__platform-features__inner col-10 sm-col-8 lg-col-6 mx-auto'>
          <h2 className='h2 center strong mb4'>Platform Features</h2>
          <HomePagePlatformFeaturesList
            className='flex flex-wrap'
            features={PLATFORM_FEATURES}
          />
        </div>
      </PageSection>

      <PageSection extraClass='homepage__conclusion bg-white'>
        <div className='homepage__conclusion__inner'>
          <div className='homepage__conclusion__body flex flex-column justify-between items-center relative'>
            <HomePageAnimatedHotel />
            <div className='homepage__conclusion__text col-10 mx-auto center mb4'>
              <p className='homepage__conclusion__title white strong'>
                {privacySectionTitle}
              </p>
              <p className='homepage__conclusion__subtitle text-para text-para--light maxw-text mx-auto'>
                {privacySectionSubtitle}
              </p>
            </div>
          </div>
        </div>
      </PageSection>

      <PageSection extraClass='maxw-xxlarge bg-white mx-auto'>
        <GenericCtaModule
          headerTitle={bottomCtaTitle}
          buttonLabel={bottomCtaButtonLabel}
          buttonHref={MAKERS_URL}
          buttonOnClick={e => trackEvent('MakersLink', { context: 'HomePage' })}
        />
      </PageSection>

      {IS_PROD &&
        !IS_SANDBOX && (
          <img
            className='absolute'
            src='https://r.snips.ai/i?sid=snips-ai&ssid=home'
          />
        )}
    </main>
  )
}

export default HomePage



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/HomePage.js